<template>
  <transition name="slide-fade" mode="out-in">
    <div id="report" v-wechat-title="$route.meta.title">
      <van-nav-bar
        title="麻丘镇一键举报"
        fixed
        left-arrow
        @click-left="onClickLeft"
      />
      <div class="main">
        <img src="@/assets/report-bg.png" class="bg" />
        <!-- <div class="cantact">
          <div class="div1">
            <a href="tel:0791-88260036">举报电话：0791-88260036</a>
          </div>
          <div class="div2">电子邮箱：ncgxmq@163.com</div>
        </div>-->
        <div class="btns">
          <div class="btn btn1 animated fadeInLeftBig" @click="toInfo(1)">
            <img src="@/assets/icon1.png" />
            <div>违反中央八项规定精神</div>
          </div>

          <div class="btn btn2 animated fadeInRightBig" @click="toInfo(2)">
            <img src="@/assets/icon2.png" />
            <div>侵害群众身边利益的微腐败问题</div>
          </div>
          <div class="btn btn3 animated fadeInLeftBig" @click="toInfo(3)">
            <img src="@/assets/icon3.png" />
            <div>“四风”新问题</div>
          </div>
          <div class="btn btn4 animated fadeInRightBig" @click="toInfo(4)">
            <img src="@/assets/icon4.png" />
            <div>涉黑涉恶腐败和“保护伞”问题</div>
          </div>
          <div class="btn btn5 animated fadeInLeftBig" @click="toInfo(5)">
            <img src="@/assets/icon5.png" />
            <div>其他</div>
          </div>
        </div>
        <div class="index-right">
          <div class="phone">
            <a href="tel:0791-88260036">
              <img src="@/assets/phone.png" />
            </a>
          </div>
          <div class="email" :class="{ width: email }">
            <img src="@/assets/email.png" @click="toShow()" />
            <div>ncgxmq@163.com</div>
            <!-- <div v-show="email" class="email-div animate__animated animate__fadeIn">电子邮箱：ncgxmq@163.com</div> -->
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
import { NavBar } from "vant";
export default {
  components: {
    [NavBar.name]: NavBar,
  },
  data() {
    return {
      visible: true,
      email: false,
      width: false,
      type: "",
    };
  },
  mounted() {
    var type = this.$route.query.type;
    if (type == 1) {
      this.type = 1;
    }
  },
  methods: {
    onClickLeft() {
      if (this.type == 1) {
        this.$router.push({
          path: "/notice",
          query: { type: 1 },
        });
      } else {
        this.$router.push("/notice");
      }
    },
    toInfo(t) {
      this.$router.push({
        path: "/form",
        query: {
          type: t,
        },
      });
    },
    toShow() {
      this.email = !this.email;
    },
  },
};
</script>
<style scoped>
.cantact {
  display: flex;
  position: absolute;
  top: 31%;
  color: #ff1106;
  font-size: 0.6rem;
  width: 100%;
  text-align: center;
  font-weight: bold;
}
.cantact .div1 {
  width: 50%;
}
.div2 {
  width: 54%;
}
.width {
  width: 10rem !important;
  transition: width 0.5s;
}
.cantact a {
  color: #ff1106;
}
.index-right img {
  width: 100%;
}
.phone,
.email {
  position: fixed;
  z-index: 2;
  top: 29%;
  right: 0;
  width: 2rem;
  background: #ffa79f;
  /* padding: 0.3rem 0; */
  /* height: 1.5rem; */
  /* line-height: 1.5rem; */
  padding-top: 0.2rem;
  border-radius: 15px 0px 0px 15px;
}
.phone img {
  width: 1rem;
  height: 1rem;
}
.email img {
  width: 1.1rem;
  height: 1.1rem;
  margin: 0 0.5rem 0.2rem;
}
.email {
  /* margin-top: 0.5rem; */
  display: flex;
  top: 33%;
  color: #ff1106;
  font-size: 0.9rem;
  transition: width 0.5s;
}
.email-div {
  position: absolute;
}
.animated {
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}
.fadeInLeftBig {
  -webkit-animation-name: fadeInLeftBig;
  animation-name: fadeInLeftBig;
}
.fadeInRightBig {
  -webkit-animation-name: fadeInRightBig;
  animation-name: fadeInRightBig;
}
#report {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
#report .bg {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  z-index: -1;
  /* top: -2px; */
}
.btns {
  margin: 0 auto;
  width: 100%;
  /* position: relative;
    top: 52%; */
  /* margin-top: -100px; */
  position: absolute;
  top: 37%;
  overflow: hidden;
}
.btn {
  display: flex;
  color: white;
  width: 68%;
  margin: 0 auto;
  /* line-height: 2.5rem; */
  padding: 0.6rem 1rem;
  /* background: rebeccapurple; */
  border-radius: 5px;
  background-image: linear-gradient(to bottom, #f3af40, #f5651a);
  font-size: 0.9rem;
  font-weight: bold;
  margin-bottom: 1.2rem;
}
.btn2 {
  background-image: linear-gradient(to bottom, #c6c553, #b5a039);
  animation-delay: 0.2s;
  -webkit-animation-delay: 0.2s; /* Safari 和 Chrome */
}
.btn3 {
  background-image: linear-gradient(to bottom, #f5c35f, #f2ac3c);
  animation-delay: 0.4s;
  -webkit-animation-delay: 0.4s; /* Safari 和 Chrome */
}
.btn4 {
  background-image: linear-gradient(to bottom, #a7ce4e, #94c33b);
  animation-delay: 0.6s;
  -webkit-animation-delay: 0.6s; /* Safari 和 Chrome */
}
.btn5 {
  background-image: linear-gradient(to bottom, #82c96e, #69bc50);
  animation-delay: 0.8s;
  -webkit-animation-delay: 0.8s; /* Safari 和 Chrome */
}
.btn img {
  width: 1.2rem;
  height: 1.2rem;
}
.btn div {
  margin-left: 1.5rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.main {
  height: 100%;
  width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/page/report.vue